// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WUmV","colBig":"styles_colBig__HuFmj","colSmall":"styles_colSmall__1nTq0"};